/** Configuration to idendify the usage of the Markdown component and the props needed.  */
export const previewConfiguration = {
  CATALOG_EDIT_LONG_DESCRIPTION: {
    title: __('Long Description'),
    field: 'long_description',
    mode: 'htmlmixed',
  },
};
